/**
 * Gemini provider adapter.
 *
 * Client-side only, per project decision (static SPA on GitHub Pages, no
 * backend). The API key is read from a build-time env var and IS visible in
 * the shipped bundle — acceptable for this dev/personal-use version only.
 *
 * Every adapter in providers/ exports the same shape: { name, ask(query) }.
 * ask() resolves to a plain string answer, or null if the provider can't
 * help (missing key, network error, empty response) — the router moves on
 * to the next provider whenever null/an error comes back.
 */

// gemini-1.5-flash was retired by Google (generateContent now returns 404
// for it) — gemini-2.5-flash is the current stable, no-billing-required
// equivalent. Override via REACT_APP_GEMINI_MODEL if needed.
const DEFAULT_MODEL = "gemini-2.5-flash";

async function ask(query) {
  const apiKey = process.env.REACT_APP_GEMINI_API_KEY;
  if (!apiKey || !query) return null;

  const model = process.env.REACT_APP_GEMINI_MODEL || DEFAULT_MODEL;
  const url = `https://generativelanguage.googleapis.com/v1beta/models/${model}:generateContent?key=${apiKey}`;

  try {
    const res = await fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        contents: [{ role: "user", parts: [{ text: query }] }],
      }),
    });

    if (!res.ok) {
      const error = await res.json().catch(() => null);
      console.error("Gemini provider error:", res.status, error);
      return null;
    }

    const data = await res.json();
    return data?.candidates?.[0]?.content?.parts?.[0]?.text?.trim() || null;
  } catch (e) {
    console.error("Gemini provider network error:", e);
    return null;
  }
}

const geminiProvider = { name: "gemini", ask };
export default geminiProvider;